import React, { Component } from 'react';
import { View } from '../UIElements/All.js';
import { isRetail, getCookie, setCookie } from '../Managers/Utils';
// import Button from '@lightspeed/cirrus-button';
var LocalizationManager = require('../Managers/LocalizationManager.js');
const DEFAULT_PHONE_LOCALES = [{"Region":"CA","Code":"1"}];

class ReUpPhoneNumberInput extends Component {
  constructor(props) 
  {
    super(props);

    var state = {};
    state.isInError = props.isInError;
    state.currentPhoneNumber = "";
    state.currentPredictedPhoneNumber = "";
    state.currentCountryIndex = 0;
    state.phoneLocales = (this.props.phoneLocales == null || typeof this.props.phoneLocales === 'undefined' || this.props.phoneLocales.length <= 0) ? [{"Region":"CA","Code":"1"}] : this.props.phoneLocales;
    state.placeholder = "";

    var countrySelected = state.phoneLocales[0].Code;
    state.preferredCountryIndex = 0;
    for( var i = 0; i < state.phoneLocales.length; i++ )
    {
      if( state.phoneLocales[i].Code == countrySelected )
      {
        state.preferredCountryIndex = i;
        state.currentCountryIndex = i;
        break;
      }
    }
    this.state = state;
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    var self = this;
    if (isRetail()){
      LocalizationManager.localizedStringForKey("ENTER_PHONE_NUMBER_TIP_TITLE", [], (retrievedString)=>
      {
        self.setState({placeholder: retrievedString})
      });
    }
  }

  componentWillUnmount()
  {
    this.unfocus();
  }

  // focus()
  // {
  //   window._phoneInput = this;
  //
  //   document.addEventListener('keyup', this.handleKeyPress, false);
  // }

  unfocus()
  {
    document.removeEventListener('keyup', this.handleKeyPress, false);
  }

  getCountryCode()
  {
    return this.state.phoneLocales[this.state.currentCountryIndex].Code;
  }

  setPhoneNumber(currentPhoneNumber)
  {
    var currentPhoneNumber = currentPhoneNumber.substring(0, 20);
    if( this.state.currentPredictedPhoneNumber.length > 0 && this.state.currentPredictedPhoneNumber.indexOf(currentPhoneNumber) !== 0 )
    {
      this.props.needsNewPredictedPhoneNumber(currentPhoneNumber);
      this.setState({currentPredictedPhoneNumber:""})
    }

    this.setState({currentPhoneNumber});

    this.props.phoneNumberChanged(this.getCountryCode() + currentPhoneNumber);
  }

  setFullPhoneNumber(fullPhoneNumber)
  {
    var currentCountryCode = this.getCountryCode();
    var needsNewCountryCode = fullPhoneNumber.indexOf(currentCountryCode) !== 0;
    if( needsNewCountryCode )
    {
      var fullPhoneNumberHasThisCountryCode = false;
      for( var i = 0; i < this.state.phoneLocales.length; i++ )
      {
        var phoneLocale = this.state.phoneLocales[i];
        fullPhoneNumberHasThisCountryCode = fullPhoneNumber.indexOf(phoneLocale.Code) === 0;
        if( fullPhoneNumberHasThisCountryCode )
        {
          var phoneNumber = fullPhoneNumber.substring(phoneLocale.Code.length, fullPhoneNumber.length);
          this.setState({currentCountryIndex:i});
          this.setState({currentPhoneNumber: phoneNumber});
          this.getFormattedPhoneNum(fullPhoneNumber.substring(0, phoneLocale.Code.length), phoneNumber, this.state.currentPhoneNumber);
          this.props.phoneNumberChanged(fullPhoneNumber);
          break;
        }
      }
      if (!fullPhoneNumberHasThisCountryCode){
        this.setPhoneNumber(fullPhoneNumber);
        this.getFormattedPhoneNum(this.getCountryCode(), fullPhoneNumber, this.state.currentPhoneNumber);
      }
    }
    else
    {
      var phoneNumber = fullPhoneNumber.substring(currentCountryCode.length, fullPhoneNumber.length);
      this.setPhoneNumber(phoneNumber);
      this.getFormattedPhoneNum(fullPhoneNumber.substring(0, currentCountryCode.length), phoneNumber, this.state.currentPhoneNumber);
    }
  }

  setPredictedPhoneNumber(predictedPhoneNumber)
  {
    this.setState({predictedPhoneNumber})
  }

  getPhoneNumber()
  {
    return this.getCountryCode() + this.state.currentPhoneNumber;
  }

  getPredictedPhoneNumber()
  {
    return this.state.currentPredictedPhoneNumber;
  }

  handleKeyPress(event)
  {
    if (typeof window.event != 'undefined')
    {
      document.onkeydown = function()
      {
        if (event.srcElement.tagName.toUpperCase() != 'INPUT')
          return (event.keyCode != 8);
      }
    }
    else
    {
      document.onkeypress = function(e)
      {
        if (e.target.nodeName.toUpperCase() != 'INPUT')
          return (e.keyCode != 8);
      }
    }

    const keyName = event.key;
    if( !isNaN(keyName) && keyName.trim().length > 0 ) window._phoneInput.numSelected(keyName);

    if( keyName == "Backspace" ) window._phoneInput.deleteSelected();
    if( keyName == "Enter" ) window._phoneInput.okSelected();
  }

  deleteSelected()
  {
    this.setPhoneNumber(this.state.currentPhoneNumber.substring(0, Math.max(0, this.state.currentPhoneNumber.length-1)));
  }

  numSelected(num)
  {
    var newPhoneRaw = this.state.currentPhoneNumber + num;
    this.setPhoneNumber(newPhoneRaw);
  }

  clearSelected()
  {
    this.setPhoneNumber("");
  }

  countrySelected(index)
  {
    this.setState({currentCountryIndex:index});
    this.props.phoneNumberChanged(this.state.phoneLocales[index].Code + this.state.currentPhoneNumber);
    this.getFormattedPhoneNum(this.state.phoneLocales[index].Code, this.state.currentPhoneNumber, null);
  }

  okSelected()
  {
    this.props.okSelected();
  }

  getCountryCodeFromFullPhoneNumber(phoneNumber)
  {
    for( var i = 0; i < this.state.phoneLocales.length; i++ )
    {
      var code = this.state.phoneLocales[i].Code;
      if( phoneNumber.indexOf(code) === 0 ) return code;
    }

    return null;
  }

  handleChange(event) {
      event.persist();
      this.props.phoneNumberChanged(this.getCountryCode() + event.target.value);
      this.getFormattedPhoneNum(this.getCountryCode(),event.target.value, this.state.currentPhoneNumber, event.target);
    }

  getFormattedPhoneNum(countryCode, input, previousInput, inputField = null)
    {
      if (!input){
          this.setState({currentPhoneNumber: input })
        }

      // only allows 0-9 inputs
      var currentValue = input.replace(/[^\d]/g, '');
      var caretStart = null;
      var caretEnd = null;
      if( inputField != null ) {
        caretStart = inputField.selectionStart;
        caretEnd = inputField.selectionEnd;
      }
      var newCurrentValue = null;

      if(countryCode == 1){
        var cvLength = currentValue.length;

        if (previousInput != input ) {
          if (cvLength < 4){
            newCurrentValue = currentValue;
          }
          else if (cvLength < 7){
            newCurrentValue = `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
            }
          else {
            newCurrentValue = `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6)}`;
          }

          if( inputField != null )
          {
            const atLeastOneDashAdded = input.length < newCurrentValue.length;
            const atLeastTwoDashesAdded = input.length+1 < newCurrentValue.length;
            if( caretStart > 3 && atLeastOneDashAdded ) caretStart++;
            if( caretStart > 7 && atLeastTwoDashesAdded ) caretStart++;
            if( caretEnd > 3 && atLeastOneDashAdded ) caretEnd++;
            if( caretEnd > 7 && atLeastTwoDashesAdded ) caretEnd++;
          }
        }
      }
      else{
        newCurrentValue = currentValue;
      }

      if( inputField == null ) {
        this.setState({currentPhoneNumber: newCurrentValue})
      }
      else {
        const completion = ()=>{
          inputField.setSelectionRange(caretStart, caretEnd);
        };
        this.setState({currentPhoneNumber: newCurrentValue}, completion)
      }
  }

  render() 
  {
    var self = this;
    console.log("this.state.preferredCountryIndex",this.state.preferredCountryIndex, this.state.currentCountryIndex)
    return (
      <View style={this.props.style}>
        <View style={{flex:1, alignSelf:'stretch', flexDirection:'row', borderRadius:4, backgroundColor: this.props.colors.input1Background, color:this.props.colors.input1Text, fontSize:32, borderWidth:1, borderStyle:'solid', borderColor:this.props.isInError ? this.props.colors.input1ErrorBackground : this.props.colors.input1Border}}>
          <View style={{flex:-1, alignSelf:'stretch', width: 120, borderRightWidth:1, borderRightStyle:'solid'}}>
            <select style={{height:"100%", width:"100%", textAlignLast:'center', borderWidth:0, backgroundColor:'transparent', fontSize:30, fontWeight:'regular', color:this.props.colors.text4}}
              value={this.state.currentCountryIndex}
              onChange={(event)=>
              {
                self.countrySelected(event.target.value);
              }}>
              {
                this.state.preferredCountryIndex >= 0 ?
                  <option value={this.state.preferredCountryIndex}>{"+" + this.state.phoneLocales[this.state.preferredCountryIndex].Code}</option>
                :
                  null
              }
              {
                this.state.preferredCountryIndex >= 0 ?
                  <option disabled>{"───"}</option>
                :
                  null
              }
              {
                this.state.phoneLocales.map((country, index) =>
                {
                  if( index == self.state.preferredCountryIndex ) return null;

                  return <option value={index} key={index}>{"+" + country.Code}</option>
                })
              }
            </select>
          </View>
          <View style={{flex:1, alignSelf:'stretch', position:'relative', flexDirection:'row', alignItems:'center', textAlign:'right', justifyContent:'center', padding:4, opacity:1}}>
            <View style={{flex:-1, position:'absolute', left:0, right:0, bottom:2, top:2, opacity:.6, fontFamily:"monospace", borderRadius:4, flexDirection:'row', alignItems:'center', textAlign:'right', justifyContent:isRetail() ? 'flex-start' : 'center', color:this.props.colors.input1Text, fontSize:32, paddingLeft:12}}>
            {this.state.currentPredictedPhoneNumber}
            </View>
            <input
              placeholder={this.state.placeholder}
              value = {this.state.currentPhoneNumber}
              maxLength = "16"
              onChange={this.handleChange}
              style={{flex:-1, position:'relative', left:0, right:0, bottom:2, top:2, border:0, width:'100%', opacity:1, flexDirection:'row', alignItems:'Center', textAlign:'left', justifyContent:isRetail() ? 'flex-start' : 'center', color:this.props.colors.input1Text, fontSize:32, paddingLeft:12}}>
            </input>
          </View>
        </View>
      </View>
    );
  }
}

ReUpPhoneNumberInput.defaultProps = {
  style: {},
  phoneLocales: DEFAULT_PHONE_LOCALES,
  phoneNumberChanged: ()=>{},
  countryChanged: ()=>{},
  okSelected: ()=>{},
  needsNewPredictedPhoneNumber: (phoneNumber)=>{}
};

export default ReUpPhoneNumberInput;